
import pwaControl from '~/mixins/pwaControl'
import notifications from '~/mixins/notifications'

export default {
  mixins: [pwaControl, notifications],
  auth: false,
  props: ['error'],
  layout: 'login',
  mounted () {
    if (this.error.redirect_to_users) {
      this.$router.push(this.localePath('/users?alert_type=is-danger&alert=') + this.error.redirect_message)
    }
  }
}
